import axios from 'axios';
import setAuthToken from '../../util/setAuthToken';
import { baseUrl } from '../../_api';
import { ADMIN_LOGIN_FAIL, ADMIN_LOGIN_SUCCESS } from './actionType';

const adminAuth = (data) => (dispatch) => {
  console.log('data', data);
  axios
    .post(`${baseUrl}/api/private/login-admin`, data, { withCredentials: true })
    .then((res) => {
      localStorage.setItem('user', JSON.stringify(res.data.user));
      setAuthToken(res.data);
      dispatch({
        type: ADMIN_LOGIN_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err.response);
      dispatch({
        type: ADMIN_LOGIN_FAIL,
        payload: err.response.data,
      });
    });
};

export { adminAuth };
